import React from 'react';
import ReactDOM from 'react-dom';
import * as Customer from './customer.js';
import * as Item from './item.js';
import * as Auth from './auth.js';

import * as Household from './household.js';
import * as $ from 'jquery';


export class View extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            screen: "loading",
            extraData: {}
        };
    }

    render() {
        var ViewContent;
        var ExtraUIHidden = false;

        switch (this.state.screen) {
            case "loading":
                ViewContent = <span><br /><div class="mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active"></div></span>
                ExtraUIHidden = true
                break;
            case "login":
                ViewContent = <Auth.Login />
                ExtraUIHidden = true
                break;
            case "customerList":
                ViewContent = <span><br /><div class="mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active"></div></span>
                Customer.GetArray()
                break;
            case "customerListReal":
                ViewContent = <Customer.List />
                break;
            case "customerAdd":
                ViewContent = <Customer.Add />
                break;
            case "customerEdit":
                ViewContent = <Customer.Edit />
                break;
            case "itemList":
                ViewContent = <Item.List />
                break;
            case "itemAdd":
                ViewContent = <Item.Add />
                break;
            case "itemEdit":
                ViewContent = <Item.Edit />
                break;
            case "settings":
                ViewContent = <Settings />
                break;
            default:
                ViewContent = <span>Nothing Loaded</span>
        }
        
        if (ExtraUIHidden) {
            return (
                    <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
                    <header class="mdl-layout__header">
                        <div class="mdl-layout__header-row">
                            <span class="mdl-layout-title">Antipy Invoice</span>
                            <div class="mdl-layout-spacer"></div>
                        </div>
                    </header>
                    <div class="demo-drawer mdl-layout__drawer mdl-color--blue-grey-900 mdl-color-text--blue-grey-50">
                        <header class="demo-drawer-header">
                            <h5>Please Sign In</h5>
                        </header>
                        <nav class="demo-navigation mdl-navigation mdl-color--blue-grey-800">
                            <a class="mdl-navigation__link" onClick={() => State("login", true)}><i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">perm_identity</i><span >Log in</span></a>
                        </nav>
                    </div>                    
                    <main class="mdl-layout__content">
                        <div class="page-content">
                            <center>
                                {ViewContent}
                            </center>
                        </div>
                    </main>
                </div>
            )
        } else {
            return (
                <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
                    <header class="mdl-layout__header">
                        <div class="mdl-layout__header-row">
                            <span class="mdl-layout-title">Antipy Invoice</span>
                            <div class="mdl-layout-spacer"></div>
                            <button class="mdl-button mdl-js-button mdl-button--icon large-screen" onClick={() => State("loading", false)}><i class="material-icons">home</i></button>&nbsp;&nbsp;&nbsp;
                            <button class="mdl-button mdl-js-button mdl-button--icon large-screen" onClick={() => State("customerList", false)}><i class="material-icons">contacts</i></button>&nbsp;&nbsp;&nbsp;
                            <button class="mdl-button mdl-js-button mdl-button--icon large-screen" onClick={() => State("itemList", false)}><i class="material-icons">apps</i></button>&nbsp;&nbsp;&nbsp;
                            <button class="mdl-button mdl-js-button mdl-button--icon large-screen" onClick={() => State("loading", false)}><i class="material-icons">ballot</i></button>&nbsp;&nbsp;&nbsp;
                            <button class="mdl-button mdl-js-button mdl-button--icon large-screen" onClick={() => State("loading", false)}><i class="material-icons">euro_symbol</i></button>&nbsp;
                        </div>
                    </header>
                    <div class="demo-drawer mdl-layout__drawer mdl-color--blue-grey-900 mdl-color-text--blue-grey-50">
                        <header class="demo-drawer-header">
                            <img src="https://cdn.antipy.com/assets/favicons/android-chrome-512x512.png" alt="" class="demo-avatar" />
                            <div class="demo-avatar-dropdown">
                                <span>invoice@antipy.com</span>
                                <div class="mdl-layout-spacer"></div>
                                <button id="accbtn" class="mdl-button mdl-js-button mdl-js-ripple-effect mdl-button--icon">
                                    <i class="material-icons" role="presentation">arrow_drop_down</i>
                                    <span class="visuallyhidden">Accounts</span>
                                </button>
                                <ul class="mdl-menu mdl-menu--bottom-right mdl-js-menu mdl-js-ripple-effect" for="accbtn">
                                    <li class="mdl-menu__item" onClick={function() {localStorage.setItem("auth", "{}"); State("login", true); }}><i class="material-icons">power_settings_new</i>&nbsp;&nbsp;&nbsp;Logout this account...</li>
                                </ul>
                            </div>
                        </header>
                        <nav class="demo-navigation mdl-navigation mdl-color--blue-grey-800">
                            <a class="mdl-navigation__link" onClick={() => State("loading", true)}><i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">home</i>Home</a>
                            <a class="mdl-navigation__link" onClick={() => State("customerList", true)}><i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">contacts</i>People</a>
                            <a class="mdl-navigation__link" onClick={() => State("itemList", true)}><i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">apps</i>Items</a>
                            <a class="mdl-navigation__link" onClick={() => State("loading", true)}><i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">ballot</i>Estimates</a>
                            <a class="mdl-navigation__link" onClick={() => State("loading", true)}><i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">euro_symbol</i>Invoices</a>
                            <div class="mdl-layout-spacer"></div>
                            <a class="mdl-navigation__link" onClick={() => State("loading", true)}><i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">help_outline</i><span class="visuallyhidden">Help</span></a>
                        </nav>
                    </div>                    
                    <main class="mdl-layout__content">
                        <div class="page-content">
                            <center>
                                {ViewContent}
                            </center>
                        </div>
                    </main>
                </div>
            );
        }
    }
}

Auth.checkIfLoggedIn()

class Settings extends React.Component {
    render() {
        return null
    }
}

var container = document.getElementById('root');

export var ViewComponent = ReactDOM.render(
    <View id="View"/>,
    container
);

export function State(state, sidebar, extraData) {
    if (!extraData) {
        extraData = {}
    }

    ViewComponent.setState({
        screen: state,
        extraData: extraData
    })

    if (sidebar === true) {
        document.getElementsByClassName("mdl-layout__drawer-button")[0].click()   
    }

    ViewComponent.render()
    setTimeout("componentHandler.upgradeDom()", 100);
}


// WEBPACK FOOTER //
// ./src/view.js